module.exports = __webpack_public_path__ + "static/media/phone-call-contact.6500f511.jpg";